import * as React from 'react';
export const oldnationalSvg = React.forwardRef(function oldnationalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#114C96',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7 6h17.967v3.32H7V6Z',
      fill: '#FFC425',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.033 11.003H25v9.973H7.033v-9.973Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7 22.647h17.967V26H7v-3.353Z',
      fill: '#FFC425',
    }),
  );
});
oldnationalSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var oldnational = {
  category: 'brand',
  colorable: false,
  name: 'oldnational',
  svg: oldnationalSvg,
};
